import { getContentObjects } from '../../../lib/flotiq-client';
import { parseResponseErrors } from '../../../lib/flotiq-client/response-errors';

export const getObjectToNavigate = async (
  jwt?: string,
  contentTypeName?: string,
) => {
  if (!jwt || !contentTypeName) {
    return;
  }

  const { body, status, ok } = await getContentObjects(jwt, undefined, {
    contentTypeName,
    limit: 1,
    page: 1,
  });

  if (!ok) {
    throw parseResponseErrors(body, status);
  }

  return body.data[0];
};

export default getObjectToNavigate;
